import React from "react";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { DropdownSelectOption, DropdownSelectOptionsGroup } from "..";
import { HStack, Pressable, Text } from "../../../primitive";
import { CheckBox } from "../../CheckBox/CheckBox";
import { Item } from "./Item";

type GroupProps<T> = {
  isMulti?: boolean;
  group: DropdownSelectOptionsGroup<T>;
  selectedItems: DropdownSelectOption<T>[] | null;
  onItemPress: (value: T) => void;
  selectAllInGroup?: (group: DropdownSelectOptionsGroup<T>) => void;
  testID?: string;
};

export const Group = <T extends string | number | null>({
  isMulti,
  group,
  selectedItems,
  onItemPress,
  selectAllInGroup,
  testID,
}: GroupProps<T>) => {
  const optionsInGroup = group?.options?.map((item, itemIndex) => {
    const itemIsSelected = !!selectedItems?.find(
      (selectedItem) => selectedItem?.value === item.value
    );

    return (
      <Item
        key={`${item.value}-${item.label}`}
        isMulti={isMulti}
        item={item}
        isSelected={itemIsSelected}
        onPress={() => onItemPress(item.value)}
        testID={testID ? `${testID}-${item.label}` : `${item.label}`}
      />
    );
  });

  const isAllInGroupSelected = group.options.every((option) =>
    selectedItems?.find((selectedItem) => selectedItem?.value === option.value)
  );

  return (
    <>
      {group.label !== "" ? (
        <Pressable
          width="100%"
          onPress={() =>
            selectAllInGroup ? selectAllInGroup(group) : undefined
          }
          testID={testID}
        >
          <HStack
            justifyContent="space-between"
            width="100%"
            paddingVertical={3}
            paddingHorizontal={4}
          >
            <Text
              textTransform="uppercase"
              variant="mainSmallSemiBold"
              color={"text-secondary"}
            >
              {group.label}
            </Text>
            {isMulti ? (
              <Box pointerEvents="none">
                <CheckBox isChecked={isAllInGroupSelected} />
              </Box>
            ) : null}
          </HStack>
        </Pressable>
      ) : null}
      {optionsInGroup}
    </>
  );
};
